export default {
  phone: '800 314 314',
  openingHours: 'Po–Pá 9–17 hod',
};
